export default (row, service, payment, price, additional) => {
  var elem = document.querySelector(".printing-container");
  if (elem) elem.parentNode.removeChild(elem);

  var container = document.createElement("div");
  container.className = "printing-container";

  let innerHTML = `
        <div class="logo">
            <img src="/logo-wewash.jpg" alt="">
            <p><b>Товарний чек</b></p>
            <p>099 731 52 47, 096 301 90 39</p>
            <p>вул. Чорноморська, 4а</p>
        </div>
        <hr>
        <div class="list-data">
            <p>
                <b>Дата-номер</b>
                <span>${row.internal_id}</span>
            </p>
            <hr>
            ${
              row.card_id
                ? `<p><b>Картка №</b><span>${row.card_id}</span></p>`
                : ""
            }
            
            <p>
                <b>Ім'я</b>
                <span>${row.name}</span>
            </p>
            <p>
                <b>Актуальна вага</b>
                <span>${row.weight}кг</span>
            </p>
            <p>
                <b>К-ть пакетів</b>
                <span>${row.parts}</span>
            </p>

            <hr>

            <p>
                <b class="center">Послуга</b>
                <b class="center">Ціна</b>
                <b class="center">Округ.Вага</b>
                <b class="center">Загалом</b>
            </p>
            <p>
                <span class="center">${service.name}${
    additional ? ` (${additional.name})` : ""
  }</span>
                <span class="center">${service.price}грн/кг</span>
                <span class="center">${row.rounded_weight}кг</span>
                <span class="center">${
                  price ? price : service.price * row.rounded_weight
                }грн</span>
            </p>

            ${
              row.comment
                ? `<hr><p><b>Коментар</b></p><p><span>${row.comment}</span></p>`
                : ""
            }

            <hr>

            <p>
                <b>Загальна ціна</b>
                <span>${
                  price ? price : service.price * row.rounded_weight
                }грн</span>
            </p>
            <p>
                <b>Оплачено</b>
                <span>${payment ? "так" : "ні"}</span>
            </p>
            ${
              payment
                ? `<p><b>Спосіб оплати</b><span>${payment}</span></p>`
                : ""
            }
            <p>
            </p>
            <hr>
            <p>
                Підпис __________, погоджуюсь з вище написаним.
            </p>
        </div>
    `;
  container.innerHTML = innerHTML;

  document.getElementById("app").appendChild(container);

  return true;
};
